module.exports = __webpack_public_path__ + "static/img/jinjichang_2.10e07ae6.png";